import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGithub, FiTwitter, FiMail, FiGlobe } = FiIcons;

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-20 border-t border-white/5 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-3 group mb-6">
              <div className="bg-white text-slate-950 w-8 h-8 rounded-lg flex items-center justify-center font-black text-sm group-hover:rotate-12 transition-transform">
                dt
              </div>
              <span className="text-xl font-black text-white tracking-tighter italic uppercase">
                DidThis<span className="text-indigo-400">.</span>social
              </span>
            </Link>
            <p className="text-slate-400 font-medium max-w-sm leading-relaxed">
              We're changing the way builders share progress. No more performance burnout. Just pure, documented effort.
            </p>
          </div>
          
          <div>
            <h4 className="text-xs font-black text-white uppercase tracking-[0.2em] mb-6">Platform</h4>
            <ul className="space-y-4">
              <li><Link to="/explore" className="text-slate-500 hover:text-white transition-colors font-bold text-sm">Explore</Link></li>
              <li><Link to="/pricing" className="text-slate-500 hover:text-white transition-colors font-bold text-sm">Pricing</Link></li>
              <li><Link to="/auth" className="text-slate-500 hover:text-white transition-colors font-bold text-sm">Join</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-black text-white uppercase tracking-[0.2em] mb-6">Connect</h4>
            <div className="flex space-x-4">
              <a href="#" aria-label="Github" className="p-3 bg-white/5 border border-white/10 rounded-xl text-slate-400 hover:text-white hover:bg-white/10 transition-all">
                <SafeIcon icon={FiGithub} className="w-5 h-5" />
              </a>
              <a href="#" aria-label="Twitter" className="p-3 bg-white/5 border border-white/10 rounded-xl text-slate-400 hover:text-white hover:bg-white/10 transition-all">
                <SafeIcon icon={FiTwitter} className="w-5 h-5" />
              </a>
              <a href="mailto:hello@didthis.social" aria-label="Email" className="p-3 bg-white/5 border border-white/10 rounded-xl text-slate-400 hover:text-white hover:bg-white/10 transition-all">
                <SafeIcon icon={FiMail} className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-600 text-[10px] font-black uppercase tracking-[0.3em]">
            &copy; {currentYear} DIDTHIS.SOCIAL &bull; BUILT BY BUILDERS
          </p>
          <div className="flex space-x-8">
            <Link to="/privacy" className="text-slate-600 hover:text-slate-400 text-[10px] font-black uppercase tracking-widest">Privacy Policy</Link>
            <Link to="/terms" className="text-slate-600 hover:text-slate-400 text-[10px] font-black uppercase tracking-widest">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;